var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusMyServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7331 11.059V17.9257C25.7331 22.0324 23.3865 23.7924 19.8665 23.7924H8.14645C7.54645 23.7924 6.97312 23.739 6.43978 23.619C6.10645 23.5657 5.78645 23.4724 5.49312 23.3657C3.49312 22.619 2.27979 20.8857 2.27979 17.9257V11.059C2.27979 6.95238 4.62645 5.19238 8.14645 5.19238H19.8665C22.8531 5.19238 24.9998 6.45905 25.5731 9.35238C25.6665 9.88572 25.7331 10.4324 25.7331 11.059Z",
    stroke: "#303030",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7347 15.0592V21.9259C29.7347 26.0325 27.3881 27.7925 23.8681 27.7925H12.1481C11.1614 27.7925 10.2681 27.6592 9.49474 27.3659C7.90807 26.7792 6.82807 25.5659 6.44141 23.6192C6.97474 23.7392 7.54807 23.7925 8.14807 23.7925H19.8681C23.3881 23.7925 25.7347 22.0325 25.7347 17.9259V11.0592C25.7347 10.4325 25.6814 9.87254 25.5747 9.35254C28.1081 9.88587 29.7347 11.6725 29.7347 15.0592Z",
    stroke: "#303030",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37305 11.5671V17.4338M21.629 11.5671V17.4338M13.997 18.0205C14.9306 18.0205 15.8259 17.6496 16.4861 16.9895C17.1462 16.3294 17.517 15.434 17.517 14.5005C17.517 13.5669 17.1462 12.6716 16.4861 12.0115C15.8259 11.3513 14.9306 10.9805 13.997 10.9805C13.0635 10.9805 12.1682 11.3513 11.508 12.0115C10.8479 12.6716 10.477 13.5669 10.477 14.5005C10.477 15.434 10.8479 16.3294 11.508 16.9895C12.1682 17.6496 13.0635 18.0205 13.997 18.0205Z",
    stroke: "#303030",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusMyServices);
export default __webpack_public_path__ + "static/media/status-my-services.40cf1b407875a14087c609c65d001ed6.svg";
export { ForwardRef as ReactComponent };